/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';

import RoundedButton from '../buttons/Rounded';
import * as FilterComponents from '../filters/index';
import FiltersIcon from '../icons/Filters';
import ResetIcon from '../icons/Reset';
import IconLink from './IconLink';

import styles from '../../../styles/partials/filters.module.scss';

const propTypes = {
    filters: AppPropTypes.filters,
    filterProps: PropTypes.shape({}),
    query: PropTypes.shape({}),
    initialQuery: PropTypes.shape({}),
    onApply: PropTypes.func,
    onChange: PropTypes.func,
    onReset: PropTypes.func,
    className: PropTypes.string,
    innerClassName: PropTypes.string,
    isOpenClassName: PropTypes.string,
    itemWrapperClassName: PropTypes.string,
};

const defaultProps = {
    filters: null,
    filterProps: null,
    query: null,
    initialQuery: null,
    onApply: null,
    onChange: null,
    onReset: null,
    className: null,
    innerClassName: null,
    isOpenClassName: null,
    itemWrapperClassName: null,
};

const Filters = ({
    query,
    initialQuery,
    filters,
    filterProps,
    onApply,
    onChange,
    onReset,
    className,
    innerClassName,
    isOpenClassName,
    itemWrapperClassName,
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div
            className={classNames([
                styles.inner,
                {
                    [innerClassName]: innerClassName !== null,
                },
            ])}
        >
            {(filters || [])
                .filter((it) => it !== null)
                .map((filter) => {
                    const {
                        id,
                        type = null,
                        mobile = true,
                        desktop = true,
                        inMenu = true,
                    } = filter || {};
                    const filterValue = query !== null && query[id] ? query[id] : null;
                    const initialValue =
                        initialQuery !== null && initialQuery[id] ? initialQuery[id] : null;
                    const onFilterChange = (newFilterValue) => {
                        if (query !== null && onChange !== null) {
                            onChange(
                                !isEmpty(newFilterValue)
                                    ? { ...query, [id]: newFilterValue }
                                    : Object.keys(query).reduce(
                                          (newQuery, key) =>
                                              key !== id
                                                  ? {
                                                        ...newQuery,
                                                        [key]: query[key],
                                                    }
                                                  : newQuery,
                                          {},
                                      ),
                            );
                        }
                    };
                    // console.log(filter, filterValue);
                    const FilterComponent = getComponentFromName(FilterComponents, type);
                    return FilterComponent !== null && inMenu ? (
                        <FilterComponent
                            key={`${filter.id}-${filter.label}`}
                            className={classNames([
                                styles.filter,
                                {
                                    [styles.hideInMobile]: mobile === false,
                                    [styles.hideInDesktop]: desktop === false,
                                },
                            ])}
                            isOpenClassName={isOpenClassName}
                            itemWrapperClassName={itemWrapperClassName}
                            filter={filter}
                            onChange={onFilterChange}
                            value={filterValue}
                            initialValue={initialValue}
                            {...filterProps}
                        />
                    ) : null;
                })}
        </div>
        {!isEmpty(query) ? (
            <div className={styles.actions}>
                <IconLink
                    className={styles.reinitializeButton}
                    icon={<ResetIcon className={styles.resetIcon} />}
                    onClick={onReset}
                    isDark
                >
                    <FormattedMessage defaultMessage="Reset" description="Button label" />
                </IconLink>
                <RoundedButton
                    className={styles.applyButton}
                    icon={<FiltersIcon />}
                    iconPosition="left"
                    onClick={onApply}
                    isDark
                >
                    <FormattedMessage defaultMessage="Apply" description="Button label" />
                </RoundedButton>
            </div>
        ) : null}
    </div>
);
Filters.propTypes = propTypes;
Filters.defaultProps = defaultProps;

export default Filters;
